var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditWithWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8273)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8273",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8273)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_8273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0234C29.7136 49.0306 34.3252 47.6516 38.2611 45.058C42.197 42.4643 45.2833 38.7705 47.1359 34.4363C48.3872 31.4971 49.0293 28.3347 49.0234 25.1403V24.8596C49.0262 21.7191 48.4057 18.6093 47.1979 15.7104C45.9902 12.8114 44.219 10.181 41.9873 7.97154C37.4728 3.48373 31.3659 0.964722 25.0004 0.964722C18.6348 0.964722 12.5279 3.48373 8.01344 7.97154C5.78172 10.1811 4.0106 12.8115 2.80269 15.7104C1.59477 18.6094 0.974068 21.7191 0.976524 24.8596V25.1403C0.974201 28.2807 1.59497 31.3904 2.80288 34.2892C4.01079 37.188 5.78184 39.8183 8.01344 42.0279C12.5249 46.5186 18.6345 49.0347 25 49.0234ZM26.7463 15.4083L33.4837 20.1258L19.5703 39.9938L13.8433 41.0045L12.8329 35.278L26.7463 15.4083ZM31.6608 9.53912C31.9781 9.539 32.2877 9.63711 32.547 9.81998L36.7505 12.7628C37.0858 12.9988 37.3139 13.358 37.385 13.7617C37.4561 14.1655 37.3645 14.581 37.1301 14.9173L34.8283 18.2041L28.0922 13.4863L30.3948 10.1996C30.5371 9.99572 30.7265 9.8292 30.9469 9.71414C31.1673 9.59908 31.4122 9.53888 31.6608 9.53863V9.53912Z",
    fill: "#F9F9F9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_8273",
    x: -15.0234,
    y: -15.0352,
    width: 70.0469,
    height: 70.0586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0.251 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_8273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_8273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWithWhiteCircle);
export default __webpack_public_path__ + "static/media/edit_with_white_circle.9c4d9ea6a67770cc8851f8fcc7370621.svg";
export { ForwardRef as ReactComponent };